import { RichSelectMenuItem } from '@/types/Ui';

export function addHeadersAndDividersToRichSelectMenuItems(
  items: RichSelectMenuItem[]
) {
  const results = [...items];
  // assuming already grouped by description
  let i = 0;
  let description = '';
  while (i < results.length) {
    if (results[i].description !== description) {
      if (i > 0) {
        results.splice(i, 0, {
          title: '',
          key: '',
          props: {
            divider: true,
            disabled: true,
          },
        });
        i = i + 1;
      }
      description = results[i].description ?? '';
      if (description !== '') {
        results.splice(i, 0, {
          title: description,
          key: '',
          props: {
            header: true,
            disabled: true,
          },
        });
        i = i + 1;
      }
    }
    i = i + 1;
  }
  return results;
}

export function addHeadersAndDividersToRichSelectMenuItemsClinic(
  items: RichSelectMenuItem[]
) {
  const results = [...items];
  // assuming already grouped by description
  let i = 0;
  let company = '';
  while (i < results.length) {
    if (results[i].company !== company) {
      if (i > 0) {
        results.splice(i, 0, {
          title: '',
          key: '',
          props: {
            divider: true,
            disabled: true,
          },
        });
        i = i + 1;
      }
      company = results[i].company ?? '';
      if (company !== '') {
        results.splice(i, 0, {
          title: company,
          key: '',
          props: {
            header: true,
            disabled: true,
          },
        });
        i = i + 1;
      }
    }
    i = i + 1;
  }
  return results;
}
